import { render, staticRenderFns } from "./Text_NoResults.vue?vue&type=template&id=0bd1ea37&scoped=true&"
import script from "./Text_NoResults.vue?vue&type=script&lang=js&"
export * from "./Text_NoResults.vue?vue&type=script&lang=js&"
import style0 from "./Text_NoResults.vue?vue&type=style&index=0&id=0bd1ea37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1ea37",
  null
  
)

export default component.exports